<template>
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <header class="modal-header">
              <a class="h3" @click="$emit('mode', 'list')">
                <!-- TODO extract svg -->
                <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="4_inspirace-detail" transform="translate(-20.000000, -44.000000)" fill="#5937B7"><g id="Top-Bar/Back-Icon"><polygon id="back-arrow" points="36 51.20625 23.8 51.20625 29.4 45.50125 28 44.075 20 52.225 28 60.375 29.4 58.94875 23.8 53.24375 36 53.24375"></polygon></g></g></g></svg>
                  {{ __('Message templates') }}
              </a>

              <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                  <svg-icon icon="close-modal" />
              </button>
          </header>

          <div class="modal-body">
              <h3>{{ __('New template') }}</h3>

              <form action="#" method="POST" @submit.prevent="update" novalidate>
                  <form-input-type-text-area
                    name="body"
                    :label="__('Message')"
                    :errors="errors.body"
                    :value="form.body"
                    auto-grow
                    required
                    margin-bottom-double
                  ></form-input-type-text-area>

                  <form-input-type-select
                    name="category"
                    :options="filteredCategories"
                    :errors="errors.category"
                    :value="form.category"
                    margin-bottom-double
                  ></form-input-type-select>

                  <div class="btn-group">
                    <VButton :label="__('Save template')" type="submit" size="lg" position="center" />
                    <VButton :label="__('Delete')" variant="ghost" color="danger" position="center" @onClick="$emit('mode', 'delete')" />
                  </div>
              </form>
          </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    template: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      form: Object.assign({}, this.template),
      errors: {},
      categories: [
        {value: 'welcome', label: lang.get('Introduction'), locale: 'cs'},
        {value: 'praise', label: lang.get('Praise'), locale: 'cs'},
        {value: 'advice', label: lang.get('Advice'), locale: 'cs'},
        {value: 'encouragement', label: lang.get('Encouragement'), locale: 'cs'},
        {value: 'farewell', label: lang.get('Goodbye'), locale: 'cs'},
        {value: 'dashboard', label: 'Vorlagen für Dashboard', locale: 'de'},
        {value: 'rwe', label: 'RWE-Studie', locale: 'de'},
        {value: 'support', label: 'Seelische Unterstützung', locale: 'de'},
        {value: 'communication', label: 'Hilfe um eine Kommunikation zu starten', locale: 'de'},
        {value: 'feedback', label: 'Feedback/ Technik', locale: 'de'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      currentConversation: 'chat/currentConversation'
    }),
    recipient () {
      return this.currentConversation ?  this.currentConversation.user : null
    },
    filteredCategories() {
      return this.categories.filter((cat) => cat.locale === this.templateLocale)
    },
    templateLocale() {
      if(this.user.locale === 'de') {
        return 'de'
      } else {
        return 'cs'
      }
    }
  },
  mounted() {
    Vuemit.listen('ChatTemplate--has-errors', this.onHasErrors)
    Vuemit.listen('ChatTemplate--success', this.onSuccess)
  },
  methods: {
    ...mapActions({
      findTemplate: 'chat-templates/findTemplate',
      updateTemplate: 'chat-templates/updateTemplate'
    }),
    update(event) {
      const data = new FormData(event.target)

      this.form.body = data.get('body')
      this.form.category = data.get('category')

      this.updateTemplate(this.form)
    },
    onHasErrors(errors) {
      this.errors = errors

      Vuemit.fire('Button--sending-failed', true)
    },
    onSuccess() {
      this.$emit('mode', 'list')
    }
  }
}
</script>
